
import { AdminGhlPendingEnrollment } from '../../models/member-coverage-model';


export const storePendingEnrollmentLocalStorage = (enrollment: AdminGhlPendingEnrollment) => {
    localStorage.setItem('pendingEnrollment', JSON.stringify(enrollment));
};

export const getPendingEnrollmentLocalStorage = (): AdminGhlPendingEnrollment => {
    return JSON.parse(localStorage.getItem('pendingEnrollment'));
};

export const removePendingEnrollmentLocalStorage = () => {
    localStorage.removeItem('pendingEnrollment');
};